import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'flag-3', 'Flag3', [["path",{"d":"M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16","key":"svg-0"}]]);